/**
 * =============================================================================
 * save-for-later.js
 * =============================================================================
 * Custom implementation of save for later functionality.
 * 
 * The SWYM Wishlist+ app 'Save for Later' feature must be enabled in app - see
 * e.g. https://admin.swymrelay.com/apps/Wishlist/features/sfl-list.
 * 
 * Had to contact their support to force the default popup to off, which should 
 * be checkable in the dev tools via 
 * '_swat.retailerSettings.SFL.PopUpSettings.PopUpEnabled' == false.
 * =============================================================================
 */

var SaveForLater = {
  listId: null, // The 'save for later' list ID

  /**
   * Initialise the save for later functionality.
   */
  init: function(){
    document.addEventListener("swym:save-for-later-list:fetched", this.handleSwymSaveForLaterListFetched.bind(this));
  },

  /**
   * Handle the 'save for later' list being fetched from SWYM.
   * 
   * @param {CustomEvent} e The event fired by SWYM when the 'save for later' list is fetched 
   */
  handleSwymSaveForLaterListFetched(e) {
    this.listId = e.detail.response.list.lid; // The 'save for later' list ID
    let swat = e.detail.swat; // The global SWYM object, provided by its callback

    // Add event listener to all 'save for later' buttons, even dynamically 
    // added ones, by setting the listener on the body and checking the target.
    document.body.addEventListener('click', e => {
      if("saveForLater" in e.target.dataset) {
        let product = JSON.parse(e.target.dataset.saveForLater);
        swat.SaveForLater.add(this.listId, [product], this.onSuccess.bind(this, e), this.onError);
      };
    });
  },

  /**
   * Handle successful save for later.
   * 
   * @param {PointerEvent} e The original click event on the 'Save' button 
   * @param {JSON} response The response response from SWYM
   */
  async onSuccess(e, response) {
    MP.Log("[S-F-L] Saved for later", response);
    MP.Utilities.toast("success", "Saved for later!");
    await MP.Extensions.Cart.onLineItemRemove(e); // Pass the original event to be handled by the cart
    MP.Log("[S-F-L] Removed from cart");
  },

  onError(error) {
    MP.Error("[S-F-L] Failed whilst saving for later", error);
    MP.Utilities.toast("danger", "Failed to save for later, please try again.");
  }
}

export default SaveForLater;